import { FiMoreHorizontal } from "react-icons/fi"
import "./style.scss"
import NotificationCard from "./NotificationCard"
import { useEffect, useState } from "react"
import { getNotifications, getNotificationsFromApi } from "../../../store/slices/notification.slice"
import { useAppDispatch, useAppSelector } from "../../../hooks/app"
import { NOTIFICATION_TYPES } from "../../../constants"
import NotificationService from "../../../services/notification.service"
import { Link } from "react-router-dom"
function NotificationDropdown() {
    const [index, setIndex] = useState(0)
    const notifications = useAppSelector(getNotifications)
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(getNotificationsFromApi())
    }, [dispatch])

    const removeNotification = async (id: string) => {
        await NotificationService.removeNotifications(id);
        dispatch(getNotificationsFromApi())
    }

    return (
        <div className="notification_dropdown">
            <div className="notification_header">
                <h3 className="heading3">Notifications</h3>
                <span><FiMoreHorizontal /></span>
            </div>
            <ul className="tabs">
                <li className={`${index === 0 ? 'active' : ''}`} onClick={() => setIndex(0)}>All</li>
                <li className={`${index === 1 ? 'active' : ''}`} onClick={() => setIndex(1)}>Achievements</li>
                <li className={`${index === 2 ? 'active' : ''}`} onClick={() => setIndex(2)}>Requests</li>
            </ul>
            {index === 0 && <div className="notifications_list">
                {notifications?.map((notification: any, i: number) => (
                    <NotificationCard removeNotification={removeNotification} key={i} notification={notification} />
                ))}
            </div>}
            {index === 1 && <div className="notifications_list">
                {notifications?.filter((n: any) => n.type === NOTIFICATION_TYPES.ENDORSEMENT_REQUEST).map((notification: any, i: number) => (
                        <NotificationCard removeNotification={removeNotification} key={i} notification={notification} />
                ))}
            </div>}
            {index === 2 && <div className="notifications_list">
                {notifications?.filter((n: any) => n.type === NOTIFICATION_TYPES.INVITATION_REQUEST || n.type === NOTIFICATION_TYPES.FLIGHT_REQUEST)?.map((notification: any, i: number) => (
                    <NotificationCard removeNotification={removeNotification} key={i} notification={notification} />
                ))}
            </div>}
        </div>
    )
}

export default NotificationDropdown